import React from 'react';
import { Layout } from '../../../v2/components/common';
import {
  AddArchitectPackages,
  PlansAndPricing,
  PricingToMatch,
  UnlockPerProperty,
  ChooseThePlan,
  PricingFAQ,
  PricingGettingStarted,
} from '../../../v2/components/pricing';

const Pricing = () => (
  <Layout title="Pricing">
    <PlansAndPricing />
    <AddArchitectPackages />
    <PricingToMatch />
    <UnlockPerProperty />
    <ChooseThePlan />
    <PricingFAQ />
    <PricingGettingStarted />
  </Layout>
);

export default Pricing;
